export const TRUE_FALSE_SELECT_OPTIONS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];

export const ZERO_ONE_SELECT_OPTIONS = [
  { name: 'Yes', value: 1 },
  { name: 'No', value: 0 },
];
export const BILL_PARTNERSHIP_SELECT_OPTIONS = [
  { name: 'Yes', value: 100000001 },
  { name: 'No', value: 100000000 },
];

export const BULK_EDIT_FIELD_LABEL_KEYS: Record<string, string> = {
  annotation: 'donorScheduling.bulkEdit.annotation',
  annotations: 'donorScheduling.bulkEdit.annotation',
  aspirationSite: 'donorScheduling.bulkEdit.aspirationSite',
  aspirationSiteId: 'donorScheduling.bulkEdit.aspirationSite',
  backupSemen: 'donorScheduling.bulkEdit.backupSemen',
  backupSemenId: 'donorScheduling.bulkEdit.backupSemen',
  backupSemenType: 'donorScheduling.bulkEdit.backupSemen',
  backupSire: 'donorScheduling.bulkEdit.backupSire',
  backupSireId: 'donorScheduling.bulkEdit.backupSire',
  billAccountCaningOption: 'donorScheduling.bulkEdit.billAccountCaning',
  billingAccount: 'donorScheduling.bulkEdit.billingAccount',
  billingAccountId: 'donorScheduling.bulkEdit.billingAccount',
  billDrugs: 'donorScheduling.bulkEdit.billDrugs',
  cane: 'donorScheduling.bulkEdit.cane',
  clinicRanchHaulIn: 'donorScheduling.bulkEdit.clinicRanchHaulIn',
  colCode: 'donorScheduling.bulkEdit.colCode',
  contractSemen: 'donorScheduling.bulkEdit.contractSemen',
  creditRebill: 'donorScheduling.bulkEdit.creditRebill',
  csr: 'donorScheduling.bulkEdit.csr',
  csrId: 'donorScheduling.bulkEdit.csr',
  date: 'donorScheduling.bulkEdit.date',
  donor: 'donorScheduling.bulkEdit.donor',
  donorId: 'donorScheduling.bulkEdit.donor',
  dow: 'donorScheduling.bulkEdit.dow',
  drugShippingFee: 'donorScheduling.bulkEdit.drugShippingFee',
  embryoComment: 'donorScheduling.bulkEdit.transferInstructions',
  export: 'donorScheduling.bulkEdit.export',
  fertilizationSite: 'donorScheduling.bulkEdit.fertilizationSite',
  fertilizationSiteId: 'donorScheduling.bulkEdit.fertilizationSite',
  freeze: 'donorScheduling.bulkEdit.freeze',
  freezeInstructions: 'donorScheduling.bulkEdit.freezeInstructions',
  freezeMethodId: 'donorScheduling.bulkEdit.freezeMethod',
  fshId: 'donorScheduling.bulkEdit.fshDrug',
  fsh2Id: 'donorScheduling.bulkEdit.fshDrug',
  loadDonorPartners: 'donorScheduling.bulkEdit.billPartnership',
  implantType: 'donorScheduling.bulkEdit.implantType',
  naab: 'donorScheduling.bulkEdit.naab',
  nonEUCountry: 'donorScheduling.bulkEdit.nonEUCountry',
  owner: 'donorScheduling.bulkEdit.owner',
  ownerId: 'donorScheduling.bulkEdit.owner',
  pool: 'donorScheduling.bulkEdit.pool',
  procedureTime: 'donorScheduling.bulkEdit.procedureTime',
  programName: 'donorScheduling.bulkEdit.programName',
  revision: 'donorScheduling.bulkEdit.revision',
  revisionComment: 'donorScheduling.bulkEdit.revisionComment',
  scheduleMaster: 'donorScheduling.bulkEdit.schedule',
  scheduleMasterId: 'donorScheduling.bulkEdit.schedule',
  scheduled: 'donorScheduling.bulkEdit.scheduleSent',
  semen: 'donorScheduling.bulkEdit.semen',
  semenComment: 'donorScheduling.bulkEdit.semenComment',
  semenId: 'donorScheduling.bulkEdit.semen',
  semenLocation: 'donorScheduling.bulkEdit.semenLocation',
  semenLocationId: 'donorScheduling.bulkEdit.semenLocation',
  semenOwner: 'donorScheduling.bulkEdit.semenOwner',
  semenOwnerId: 'donorScheduling.bulkEdit.semenOwner',
  semenPrice: 'donorScheduling.bulkEdit.semenPrice',
  semenReleased: 'donorScheduling.bulkEdit.semenReleased',
  semenType: 'donorScheduling.bulkEdit.semenType',
  separateFert: 'donorScheduling.bulkEdit.separateFert',
  ship: 'donorScheduling.bulkEdit.ship',
  shipmentGroup: 'donorScheduling.bulkEdit.shipmentGroup',
  shipmentGroupId: 'donorScheduling.bulkEdit.shipmentGroup',
  sire: 'donorScheduling.bulkEdit.sire',
  sireId: 'donorScheduling.bulkEdit.sire',
  soSchedule: 'donorScheduling.bulkEdit.soSchedule',
  soScheduleId: 'donorScheduling.bulkEdit.soSchedule',
  targetTime: 'donorScheduling.bulkEdit.targetTime',
  tt: 'donorScheduling.bulkEdit.tt',
};
